"use client";

import type { UserProfile } from "@/api";
import "@ant-design/v5-patch-for-react-19";
import { CommunitySection } from "./CommunitySection";
import { RecentProjectsSection } from "./RecentProjectsSection";

interface ThreadListProps {
  user: UserProfile | null;
}

export const ThreadList = ({ user }: ThreadListProps) => {
  return (
    <div className="pb-6 mx-auto flex flex-col gap-12 px-5 sm:px-8 md:px-10 lg:px-11">
      {user && <RecentProjectsSection />}
      <CommunitySection />
    </div>
  );
};
